export const CONTROLLED_VOCABULARY_ASSIGNMENT = "controlled-vocabulary-assignment";
export function isControlledVocabularyAssignment(entity) {
    return entity?.type.includes(CONTROLLED_VOCABULARY_ASSIGNMENT) ?? false;
}
//# sourceMappingURL=controlled-vocabulary-assignment.js.map